import React from "react"

import { ProjectMarker, ProjectRadiusMarker } from "@dashboard/ProjectMap"
import EcosuiteView from "@common/module/EcosuiteView"

import EnergyViewControls from "./EnergyViewControls"

export default class EnergyView extends EcosuiteView {
  renderViewControls() {
    return (
      <EnergyViewControls
        showConsumption={this.props.showConsumption}
        restrictions={this.props.restrictions}
        groups={this.props.groups}
        rangeName={this.props.rangeName}
        customRange={this.props.customRange}
        project={this.props.project}
        projects={this.props.projects}
        viewControls={this.getEnergyViewControls()}
      />
    )
  }

  getEnergyViewControls() {
    return null
  }
}

export class EnergyProjectMarker extends ProjectMarker {
  renderProjectInfo() {
    return (
      <React.Fragment>
        <div>{(this.props.type ? this.props.type + ": " : "Project: ") + this.props.project.name}</div>
        {this.props.showGeneration && this.props.projectReading ? <div>{"Generation: " + Math.round(this.props.projectReading.generation / 1000) + " kWh"}</div> : null}
        {this.props.showConsumption && this.props.projectReading ? <div>{"Consumption: " + Math.round(this.props.projectReading.consumption / 1000) + " kWh"}</div> : null}
        {this.props.showStorage && this.props.projectReading ? <div>{"Storage: " + Math.round(this.props.projectReading.storage / 1000) + " kWh"}</div> : null}
      </React.Fragment>
    )
  }

  getColor() {
    if (this.props.projectStatus) {
      switch (this.props.projectStatus.status) {
        case "ok":
          return "#4CAF50"
        case "warning":
          return "orange"
        case "error":
          return "#e22006"
        default:
          return "#0EB6DB"
      }
    }
    return "#0EB6DB"
  }
}

export class EnergyRadiusMarker extends ProjectRadiusMarker {
  calculateRadius() {
    if (this.props.showGeneration) {
      let projectGeneration = this.props.projectReading ? this.props.projectReading.generation : 0
      let totalGeneration = this.props.readings ? this.props.readings.generation : 0
      return (projectGeneration / totalGeneration) * 100 + 12
    } else {
      return 0
    }
  }
}
